var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('schedule',{attrs:{"record":_vm.project,"editable":_vm.is_administrator || _vm.is_db_admin_active || _vm.is_developer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }